module.exports = __webpack_public_path__ + "static/assets/c33b485ca2c1a6113f9848594496c0dc.png";